<template>

  <panel-navigation>

    <dialog-review-platform-add ref="dialogPlatform"></dialog-review-platform-add>

    <h1 class="text-lg font-semibold mb-3">Review Platforms</h1>

    <hr class="border-b border-gray-100 mb-3" />

    <v-skeleton-loader v-if="fetchingListings" type="article, article, article"></v-skeleton-loader>

    <div v-if="me">

      <template>

        <h2 class="font-bold text-gray-800 mb-3">Active Connections</h2>

        <div v-if="listings.length == 0">
          There are no active connections. Please add your connections below.
        </div>

        <div v-else>
          <div v-for="reviewplatform in active_connections" :key="reviewplatform.id" class="w-full mr-2 mb-2" :class="'float-left'" style="width: 250px !important;">
            <div class="dashboard-box">
              <v-card
                class="pa-2"
                tile
              >
                <div class="p-3">
                  <div class="text-h6 text--primary">
                    <div class="text-center">
                      <img :src="getIconUrl(reviewplatform.url)" alt="" style="height: 40px; display: initial;" />
                    </div>

                    <div class="text-center font-bold text-sm mt-2">
                      {{ reviewSitesNamesOriginal["www." + getHostname(reviewplatform.url.replace(".ca", ".com").replace("doctor.webmd", "webmd").replace("uk.trustpilot.com", "trustpilot.com").replace("ebay.co.uk", "ebay.com").replace("ebay.de", "ebay.com").replace("amazon.co.uk", "amazon.com").replace("glassdoor.co.uk", "glassdoor.com").replace("expedia.co.uk", "expedia.com").replace("tripadvisor.co.uk", "tripadvisor.com").replace("opentable.co.uk", "opentable.com").replace("airbnb.co.uk", "airbnb.com").replace("maps.app.goo.gl","google.com").replace("yellowpages.ca", "yellowpages.com"))] }}
                    </div>

                    <div style="position: absolute; right: 10px; top: 10px;">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <i
                            v-if="reviewplatform.crawl_status == 'pending' || !reviewplatform.crawl_status"
                            v-bind="attrs"
                            v-on="on"
                            class="fa fa-spinner fa-spin"
                            >
                          </i>
                        </template>
                        <span>Your reviews are being imported. <br />We will send you an email when import will be completed.</span>
                      </v-tooltip>
                    </div>
                  </div>
                </div>

                <v-card-actions class="-mt-2">
                  <v-btn
                    v-if="$store.state.auth.owner || !$agency || ($agency && $agency.settings.allow_business_to_modify_review_sites == 1)"
                    class="w-full"
                    color="blue"
                    outlined
                    small
                    @click="deleteReviewplatform(reviewplatform.id)"
                  >
                    Disconnect
                  </v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </div>
        </div>

        <br clear="all" />

        <h2 class="font-bold text-gray-800 mb-3 mt-6">Available Connections</h2>

        <div v-if="reviewSitesNamesCount == 0">
          Congratulations! You have successfully connected all available review platforms.
        </div>

        <div v-else>
          <div v-for="(reviewSite, index) in reviewSitesNames" :key="index" class="w-full mr-2 mb-2" :class="'float-left'" style="width: 250px !important;">
           <div class="dashboard-box">
              <v-card
                class="pa-2"
                tile
              >
                <div class="p-3">
                  <div class="text-h6 text--primary">
                    <div class="text-center">
                      <img :src="getIconUrl('https://' + index)" alt="" style="height: 40px; display: initial;" />
                    </div>

                    <div class="text-center font-bold text-sm mt-2">
                      {{ reviewSite }}
                    </div>
                  </div>
                </div>

                <v-card-actions class="-mt-2">
                  <v-btn
                    v-if="$store.state.auth.owner || !$agency || ($agency && $agency.settings.allow_business_to_modify_review_sites == 1)"
                    class="w-full text-white"
                    color="#2477F6"
                    small
                    @click="$refs.dialogPlatform.review_platform_url = ''; $refs.dialogPlatform.review_site = index; $refs.dialogPlatform.review_site_name = reviewSite; $refs.dialogPlatform.show()"
                  >
                    Connect
                  </v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </div>
        </div>

        <div v-if="me && me.subscription && me.subscription.stripe_id == 'starter'">
          <br clear="all" />

          <h2 class="font-bold text-gray-800 mb-3 mt-6">Widgets Only Connections</h2>

          <div v-if="reviewSitesNamesWidgetsOnlyCount == 0">
            Congratulations! You have successfully connected all available widgets only review platforms.
          </div>

          <div v-else>
            <div v-for="(reviewSite, index) in reviewSitesNamesWidgetsOnly" :key="index" class="w-full mr-2 mb-2" :class="'float-left'" style="width: 250px;">
              <div class="dashboard-box">
                <v-card
                  class="pa-2"
                  tile
                >
                  <div class="p-3">
                    <div class="text-h6 text--primary">
                      <div class="text-center">
                        <img :src="getIconUrl('https://' + index)" alt="" style="height: 40px; display: initial;" />
                      </div>

                      <div class="text-center font-bold text-sm mt-2">
                        {{ reviewSite }}
                      </div>
                    </div>
                  </div>

                  <v-card-actions class="-mt-2">
                    <v-btn
                      v-if="$store.state.auth.owner || !$agency || ($agency && $agency.settings.allow_business_to_modify_review_sites == 1)"
                      class="w-full text-white"
                      color="#2477F6"
                      small
                      @click="$refs.dialogPlatform.review_platform_url = ''; $refs.dialogPlatform.review_site = index; $refs.dialogPlatform.review_site_name = reviewSite; $refs.dialogPlatform.show()"
                    >
                      Connect
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </div>
            </div>
          </div>
        </div>

      </template>
    </div>

  </panel-navigation>

</template>

<script>
import { mapState } from 'vuex'
import urlParser from 'url-parse'
import PanelNavigation from '@/components/PanelNavigation.vue'
import MenuReviewplatformActions from '@/components/menus/menuReviewplatformActions.vue'
import DialogReviewPlatformAdd from '@/components/dialogs/dialogReviewPlatformAdd.vue'
import ListingsFinder from '@/components/ListingsFinder.vue'
import reviewSitesNames from '@/config/review_sites/names';
import reviewSitesNamesWidgetsOnly from '@/config/review_sites/names_widgets';
import axios from 'axios'

export default {
  metaInfo () {
    return {
      title: "Review Platforms | " + this.$appName
    }
  },
  components: {
    PanelNavigation,
    MenuReviewplatformActions,
    DialogReviewPlatformAdd,
    ListingsFinder
  },
  data () {
    return {
      listingFinder: false,
      listings_search_percentage: 17,
      listingsInterval: null,
      saving: false,
      savingNapScan: false,
      reviewSitesNamesOriginal: {"www.agoda.com": "Agoda","www.avvo.com": "Avvo","www.expedia.com": "Expedia","www.facebook.com": "Facebook","www.google.com": "Google","www.playstore.com": "Playstore","www.tripadvisor.com": "Tripadvisor","www.yelp.com": "Yelp","www.zillow.com": "Zillow","www.zomato.com": "Zomato","www.airbnb.com": "Airbnb","www.aliexpress.com": "Aliexpress","www.alternativeto.com": "Alternativeto","www.amazon.com": "Amazon","www.angi.com": "Angie's List","www.apartmentratings.com": "Apartmentratings","www.apartments.com": "Apartments","www.appstore.com": "Appstore","www.bbb.org": "Bbb","www.bookatable.co.uk": "Bookatable","www.booking.com": "Booking","www.capterra.com": "Capterra","www.cargurus.com": "Cargurus","www.cars.com": "Cars","www.citysearch.com": "Citysearch","www.classpass.com": "Classpass","www.consumeraffairs.com": "Consumeraffairs","www.creditkarma.com": "Creditkarma","www.customerlobby.com": "Customerlobby","www.dealerrater.com": "Dealerrater","www.ebay.com": "Ebay","www.edmunds.com": "Edmunds","www.etsy.com": "Etsy","www.findlaw.com": "Findlaw","www.foursquare.com": "Foursquare","www.g2crowd.com": "G2crowd","www.g2.com": "G2","www.gartner.com": "Gartner","www.glassdoor.com": "Glassdoor","www.greatschools.org": "Greatschools","www.healthgrades.com": "Healthgrades","www.homeadvisor.com": "Homeadvisor","www.homeaway.com.au": "Homeaway","www.homestars.com": "Homestars","www.houzz.com": "Houzz","www.hotels.com": "Hotels","www.indeed.com": "Indeed","www.influenster.com": "Influenster","www.insiderpages.com": "Insiderpages","www.itcentralstation.com": "Itcentralstation","www.lawyers.com": "Lawyers","www.lendingtree.com": "Lendingtree","www.martindale.com": "Martindale","www.niche.com": "Niche","www.openrice.com": "Openrice","www.opentable.com": "Opentable","www.producthunt.com": "Producthunt","www.productreview.com.au": "Productreview","www.ratemds.com": "Ratemds","www.realself.com": "RealSelf","www.reserveout.com": "Reserveout","www.sitejabber.com": "Sitejabber","www.softwareadvice.com": "Softwareadvice","www.talabat.com": "Talabat","www.theknot.com": "Theknot","www.thumbtack.com": "Thumbtack","www.trulia.com": "Trulia","www.trustedshops.com": "Trustedshops","www.trustpilot.com": "Trustpilot","www.trustradius.com": "Trustradius","www.vitals.com": "Vitals","www.vrbo.com":"Vrbo","www.walmart.com": "Walmart","www.webmd.com": "Webmd","www.doctor.webmd.com": "Webmd","www.weddingwire.com": "Weddingwire","www.yell.com": "Yell","www.yellowpages.com": "Yellowpages","www.zocdoc.com": "Zocdoc"},
      reviewSitesNamesCount: 3,
      reviewSitesNames: reviewSitesNames,
      reviewSitesNamesWidgetsOnlyCount: 3,
      reviewSitesNamesWidgetsOnly: reviewSitesNamesWidgetsOnly,
      active_connections: {}
    }
  },
  computed: {
    ...mapState({
      listings: state => state.listings.listings,
      listings_search: state => state.listings.listings_search,
      fetchingListings: state => state.listings.fetchingListings,
      me: state => state.me.me
    })
  },
  methods: {
    getHostname(url) {
      return urlParser(url).hostname.replace("www.", "")
    },
    getPathname(url) {
      let parsed_url = urlParser(url)

      if (url.includes("google"))
        return parsed_url.pathname + parsed_url.query

      return parsed_url.pathname
    },
    getIconUrl(url) {
      return require('@/assets/images/review-services/www.' + this.getHostname(url).replace(".ca", ".com").replace("doctor.webmd", "webmd").replace("uk.trustpilot.com", "trustpilot.com").replace("ebay.co.uk", "ebay.com").replace("ebay.de", "ebay.com").replace("amazon.co.uk", "amazon.com").replace("glassdoor.co.uk", "glassdoor.com").replace("expedia.co.uk", "expedia.com").replace("tripadvisor.co.uk", "tripadvisor.com").replace("opentable.co.uk", "opentable.com").replace("airbnb.co.uk", "airbnb.com").replace("yellowpages.ca", "yellowpages.com") + ".png");

    },
    async deleteReviewplatform(listing_id) {
      await this.$store.dispatch('listings/delete', listing_id)
      await this.$store.dispatch('listings/fetch', { dashboard: false })

      this.active_connections = {};
      for (var i in this.listings) {
        let listing = this.listings[i];
        let hostName = this.getHostname(listing.url);

        this.active_connections[hostName] = listing;
        delete this.reviewSitesNames["www." + hostName];
      }

      window.location = window.location.href;

      return;

      // this.reviewSitesNames = JSON.parse(JSON.stringify(this.reviewSitesNamesOriginal));

      // this.active_connections = {};
      // for (var i in this.listings) {
      //   let listing = this.listings[i];
      //   let hostName = this.getHostname(listing.url);

      //   this.active_connections[hostName] = listing;
      //   delete this.reviewSitesNames["www." + hostName];
      // }

      // this.reviewSitesNamesCount = 0;
      // for (var i in this.reviewSitesNames)
      //   this.reviewSitesNamesCount++;
    },
    async saveScrapeFrequency() {
      this.saving = true

      let self = this

      await this.$store.dispatch('me/save', {
        reviews_scrape_frequency: self.me.reviews_scrape_frequency,
      })

      this.saving = false

      let credits_amount = (30/self.me.reviews_scrape_frequency) * 10;
      credits_amount = parseInt(credits_amount);

      this.$swal({
        title: "Settings saved!",
        html: "Every time we submit your listing for reviews refetch, we will use <strong>10</strong> credits from your account. This will use <strong>" + credits_amount + "</strong> credits per month per listing.\
              <br /><br />\
              <a href='/billing' class=\"text-blue-500\">Click here</a> to view your credits log.\
              ",
        showCancelButton: false,
        confirmButtonText: 'OK'
      }).then(function() {

      });
    },
    listingsAdded: function() {
      console.log('listings addeddddddd')
      this.listingFinder = false
      this.$store.dispatch('me/fetch')
      this.$store.dispatch('listings/fetch', { dashboard: false })
    },
    async submitNapScan() {
      this.savingNapScan = true
      console.log(this.$refs.business_name.value)
      console.log(this.$refs.zip.value)

      try {
        let response = await axios.post(process.env.VUE_APP_API_ENDPOINT + '/me/listings/submit-nap', {
          business_name: this.$refs.business_name.value,
          zip: this.$refs.zip.value
        } , {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          },
        })

        this.savingNapScan = false

        this.$store.dispatch('listings/fetch', { dashboard: false })
      }catch(e){
        console.log(e)
      }
    },
    async dismissListingsSearch() {
      this.$store.state.listings.listings_search = false

      try {
        let response = await axios.post(process.env.VUE_APP_API_ENDPOINT + '/me/listings/dismiss-nap', {
        } , {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          },
        })

        this.savingNapScan = false
      }catch(e){
        console.log(e)
      }
    }
  },
  created() {
    this.$store.state.listings.fetchingListings = true
    this.$store.dispatch('listings/fetch', { dashboard: false })

    let hasPending = false;

    for (var i in this.listings) {
      if (this.listings[i].crawl_status == "pending" || !this.listings[i].crawl_status)
        hasPending = true;
    }

    if (this.listings_search) {
      if (this.listings_search.crawl_status == "pending")
        hasPending = true;
    }

    var that = this;

    if (hasPending) {
      that.listingsInterval = setInterval(function() {
        that.$store.dispatch('listings/fetch', { dashboard: true })
      }, 5000);
    }
  },

  beforeDestroy () {
     clearInterval(this.listingsInterval)
  },

  watch: {
    listings: function() {
      let self = this;

      function doDis() {
        try {
          self.active_connections = {};

          console.log('self.listings', self.listings)

          for (var i in self.listings) {
            let listing = self.listings[i];
            let hostName = self.getHostname(listing.url);

            if (hostName != "direct.com")
              self.active_connections[hostName] = listing;

            if (self.me.subscription.stripe_id == 'starter') {
              // if (typeof(self.reviewSitesNames["www." + hostName]) != "undefined" || 1)
                delete self.reviewSitesNames["www." + hostName];
              
              if (typeof(self.reviewSitesNamesWidgetsOnly["www." + hostName]) != "undefined")
                delete self.reviewSitesNamesWidgetsOnly["www." + hostName];
            }

            console.log('hostName', hostName)

            if (hostName == "direct.com") {
              console.log('remove directttt')
              delete self.reviewSitesNamesWidgetsOnly["www." + hostName];
            }
          }
        }
        catch (e) {
          setTimeout(function() {
            doDis();
          }, 500);
        }
      }

      doDis();
    }
  }
}
</script>

<style>
  input, select {
    border-style: solid;
  }

  .reviews-scrape-frequency input[type="number"] {
    text-align: center;
  }
</style>